import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})

export class StorageService {

	setToLocalStorage(key: string, value: string): void {
		localStorage.setItem(key, value);
	}

	getFromLocalStorage = (key: string) => localStorage.getItem(key);

	deleteFromLocalStorage(key: string): void {
		localStorage.removeItem(key);
	}

	clearLocalStorage(): void {
		localStorage.clear();
	}

	setToSessionStorage(key: string, value: string): void {
		sessionStorage.setItem(key, value);
	}

	getFromSessionStorage = (key: string) => sessionStorage.getItem(key);

	deleteFromSessionStorage(key: string): void {
		sessionStorage.removeItem(key);
	}

	clearSessionStorage(): void {
		sessionStorage.clear();
	}
}
